import { Component, OnInit, OnChanges, Input } from "@angular/core";
import { AppService } from "../../services/app.service";
import { Router } from "@angular/router";
import { SupportService } from "../../services/support-service";
import { Subscription } from "rxjs";
import { checkDate as checkDateUtil } from "../../utils/format-util";

@Component({
  selector: "app-dashboard-sidenav",
  templateUrl: "./dashboard-sidenav.component.html",
  styleUrls: ["./dashboard-sidenav.component.scss"],
})
export class DashboardSidenavComponent implements OnInit {
  bsInlineValue = new Date();
  selectedlang: any = {};
  tcCode: any = "";
  tcAddressObj = [];
  tcCountryCode = "";
  accessmanagement: any = [];
  @Input() equipmentChange: any = [];
  accessManagement: any = [];
  accessManagements: any = [];
  schedulerelatedMenu = false;
  technicianMenu = false;
  patientMenu = false;
  utilizationMenu = false;
  currentURL: any = "";
  doctorMenu = false;
  messagecenter = false;
  today = new Date();
  machineUtilization = [];
  technicianList = [];
  constructor(
    private router: Router,
    private supported: SupportService,
    private appservice: AppService
  ) {}

  unsub: Subscription;
  ngOnInit() {
    this.getAccessManagement();
    if (localStorage.getItem("testCode") != null) {
      this.tcCode = localStorage.getItem("testCode");
    }

    this.appservice.getlang().subscribe((res) => {
      this.selectedlang = res["header"];
    });
    if (sessionStorage.getItem("type")) {
      this.checkURL(sessionStorage.getItem("type"));
    } else {
      this.checkURL("home-calendar");
    }

    this.unsub = this.supported.getDateChange.subscribe((data: any) => {
      if (data.date) {
        this.bsInlineValue = new Date(data.dateVal);
      }
    });
    this.tcCountryCode = localStorage.getItem("country_code")
      ? localStorage.getItem("country_code")
      : "US";
  }

  ngOnDestroy() {
    this.unsub.unsubscribe();
  }

  getAccessManagement() {
    this.appservice.getFrontDeskAccessManagement().subscribe((res) => {
      if (res && res["entity"] && res["entity"].length > 0) {
        this.accessManagement = res["entity"];
        for (let index = 0; index < res["entity"].length; index++) {
          const groupBy =
            res["entity"][index]["accessManagement"]["accessType"];
          this.accessManagements[index] = res["entity"][index];
          this.accessManagements[index].groupBy = groupBy;
        }
        this.accessManagement = this.groupBy(this.accessManagements, "groupBy");
        this.setaccessmanagement(this.accessManagement);
      }
    });
  }

  groupBy(collection: any, property: string): any {
    if (!collection) {
      return null;
    }
    const groupedCollection = collection.reduce((previous, current) => {
      if (!previous[current[property]]) {
        previous[current[property]] = [current];
      } else {
        previous[current[property]].push(current);
      }
      return previous;
    }, {});
    return Object.keys(groupedCollection).map((key) => ({
      key,
      value: groupedCollection[key],
    }));
  }

  setaccessmanagement(value) {
    if (value) {
      for (let index = 0; index < value.length; index++) {
        if (value[index] != null && value[index].key === "Operations") {
          for (let j = 0; j < value[index].value.length; j++) {
            if (
              value[index].value[j].accessManagement.accessManagement ===
              "Schedule Appointments"
            ) {
              if (sessionStorage.getItem("usertype") === "3") {
                this.schedulerelatedMenu = value[index].value[j].frontDesk;
              } else if (sessionStorage.getItem("usertype") === "2") {
                this.schedulerelatedMenu = value[index].value[j].admin;
              }
            }

            if (
              value[index].value[j].accessManagement.subMenu ===
              "Technician Schedule"
            ) {
              if (sessionStorage.getItem("usertype") === "3") {
                this.technicianMenu = value[index].value[j].frontDesk;
              } else if (sessionStorage.getItem("usertype") === "2") {
                this.technicianMenu = value[index].value[j].admin;
              }
            }
            if (
              value[index].value[j].accessManagement.accessManagement ===
              "Patient Information"
            ) {
              if (sessionStorage.getItem("usertype") === "3") {
                this.patientMenu = value[index].value[j].frontDesk;
              } else if (sessionStorage.getItem("usertype") === "2") {
                this.patientMenu = value[index].value[j].admin;
              }
            }
            if (
              value[index].value[j].accessManagement.accessManagement ===
              "Doctor's Information"
            ) {
              console.log(this.doctorMenu);
              console.log(sessionStorage.getItem("usertype"));
              
              if (sessionStorage.getItem("usertype") === "3") {
                console.log("if");
                
                this.doctorMenu = value[index].value[j].frontDesk;
              } else if (sessionStorage.getItem("usertype") === "2") {
                console.log("else");
                this.doctorMenu = value[index].value[j].admin;
              }
              console.log(this.doctorMenu);
              
            }
            if (
              value[index].value[j].accessManagement.accessManagement ===
              "Message Center"
            ) {
              if (sessionStorage.getItem("usertype") === "3") {
                this.messagecenter = value[index].value[j].frontDesk;
              } else {
                this.messagecenter = true;
              }
            } else if (sessionStorage.getItem("usertype") === "2") {
              this.messagecenter = true;
            }
          }
        }

        if (value[index] != null && value[index].key === "Admin") {
          for (let j = 0; j < value[index].value.length; j++) {
            if (
              value[index].value[j].accessManagement.accessManagement ===
              "Analysis"
            ) {
              if (sessionStorage.getItem("usertype") === "3") {
                this.utilizationMenu = value[index].value[j].frontDesk;
              } else if (sessionStorage.getItem("usertype") === "2") {
                this.utilizationMenu = value[index].value[j].admin;
              }
            }
          }
        }
      }
    }
  }

  checkDate(str) {
    return checkDateUtil(str);
  }

  getRound(value): number {
    if (value) {
      return Math.round(value * 100) / 100;
    }
    return 0;
  }

  getMachineUtilization(data) {
    this.appservice.getUtilizationByType(data).subscribe((res) => {
      if (res && res["entity"]) {
        this.machineUtilization = res["entity"];
      }
    });
  }

  getTechnicianUtilization(data) {
    this.appservice.getUtilizationByType(data).subscribe((res) => {
      if (res && res["entity"]) {
        this.technicianList = res["entity"];
      }
    });
  }

  onValueChange(value: any): void {
    this.today = new Date(value);
    const date = this.checkDate(this.today.getDate());
    const month = this.checkDate(this.today.getMonth() + 1);
    const year = this.today.getFullYear();
    const data = {
      date: value,
      type: "emit",
    };
    this.supported.getDateChange1.next(data);
  }

  checkURL(type) {
    sessionStorage.setItem("type", type);
    if (type != null && localStorage.getItem("testCode") != null) {
      if (type) {
        this.currentURL = type;
        this.supported.sidemenuname.next("/65656/" + this.currentURL);
      }
    }
  }
}
